import { isAction, isAnyOf } from "@reduxjs/toolkit";
import dayjs from "dayjs";

import {
    addOrReplaceRequestQueueItem,
    addRequestQueueItem,
    bulkAddRequestQueueItems,
    deleteRequestQueueItem,
    normalizeRequestQueueTail,
    patchRequestQueueItem,
    restartRequestQueue,
    upsertSaleOrderUpdateRequestQueueItem,
} from "@/store/slices/offline";
import { setProgressLastModifiedAt } from "@/store/slices/offline";

import { AppMiddleware } from "../types";

export const progressTrackingMiddleware: AppMiddleware = (() => {
    let timeoutId: NodeJS.Timeout | null = null;
    const DEBOUNCE_MS = 1000;

    return (store) => (next) => (action) => {
        const result = next(action);

        if (
            isAction(action) &&
            (action.type.startsWith("progress/") ||
                isAnyOf(
                    addRequestQueueItem,
                    deleteRequestQueueItem,
                    patchRequestQueueItem,
                    addOrReplaceRequestQueueItem,
                    upsertSaleOrderUpdateRequestQueueItem,
                    restartRequestQueue,
                    normalizeRequestQueueTail,
                    bulkAddRequestQueueItems,
                )(action))
        ) {
            if (timeoutId) clearTimeout(timeoutId);

            timeoutId = setTimeout(() => {
                const timestamp = dayjs().toISOString();
                store.dispatch(setProgressLastModifiedAt(timestamp));
                timeoutId = null;
            }, DEBOUNCE_MS);
        }

        return result;
    };
})();
